import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Form, Button, TextArea } from 'formik-semantic-ui';
import { IPtwCompletionStatus } from '@relab/alstom-ptw-shared';

import { DatePicker } from '../DatePicker';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwCompletionStatusModalValues {
  completionStatus: IPtwCompletionStatus;
}

interface PtwCompletionStatusModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  onSubmit: (values: PtwCompletionStatusModalValues) => void;
}

class PPtwCompletionStatusModal extends Component<PtwCompletionStatusModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Add completion status'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Add completion status'} />
        </Modal.Header>
        <Modal.Content>
          <Form
            initialValues={{ text: '', date: null }}
            onSubmit={(values: IPtwCompletionStatus) => {
              this.toggleOpen(false);
              this.props.onSubmit({
                completionStatus: values,
              });
            }}
          >
            <DatePicker label={t('Date')} name="date" inputProps={{ placeholder: '' }} />
            <TextArea label={t('Comment')} name="text" />
            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwCompletionStatusModal = withTranslation()(PPtwCompletionStatusModal);
